import * as z from 'zod'

import surveySchema from './survey'
import createUniqueIdRefine from './zodHelpers/createUniqueIdRefine'

const surveyListSchema = z
  .object({
    surveys: z.array(surveySchema),
  })
  .superRefine(
    createUniqueIdRefine({
      getScope: data => data.surveys,
      getUniqItemsInScope: survey => survey.topics,
    })
  )

export default surveyListSchema

export type SurveyList = z.infer<typeof surveyListSchema>
